<span
    *ngIf="serviceStatus !== null"
    class="service-status-badge"
    [ngClass]="[variant, appearance, size, statusClass]"
    [attr.aria-label]="variant === 'icon' ? label : null"
    [attr.title]="label"
>
    <span
        *ngIf="showsIcon"
        class="service-status-badge__icon"
        [style.--service-status-icon]="iconMaskValue"
        aria-hidden="true"
    ></span>

    <span *ngIf="showsTitle">{{ label }}</span>
</span>